<template>
  <div>
    <v-card class="elevation-0" color="rgba(255,255,255,0)">
      <v-card-actions class="px-0 mb-2">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-2" :to="{ name: 'user' }">
          <v-icon left>mdi-account-multiple-outline</v-icon>
          {{ $t("users.btn.list.title") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <div class="mt-5 d-flex justify-center">
      <div>
        <div class="mb-4 text-subtitle-2">
          <span class="secondary-font font-weight-bold"
            >{{ $t("users.add.title") }}
          </span>
        </div>
        <v-card width="600">
          <v-card-text class="px-5">
            <user-form></user-form>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import UserForm from "./form";
export default {
  data: () => ({}),
  components: {
    UserForm,
  },
};
</script>